import { render } from "./CarriersV2.vue?vue&type=template&id=06285d6d&scoped=true"
import script from "./CarriersV2.vue?vue&type=script&lang=ts"
export * from "./CarriersV2.vue?vue&type=script&lang=ts"

import "./CarriersV2.vue?vue&type=style&index=0&id=06285d6d&scoped=true&lang=css"
import "./CarriersV2.vue?vue&type=style&index=1&id=06285d6d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-06285d6d"

export default script